import useOutsideClick from "@rooks/use-outside-click";

export const useClickOutside = ({refName, isOpen, updateIsOpen}) => {
    useOutsideClick(refName, () => {
        if (isOpen) {
            updateIsOpen(false)
        }
    });
}